import React, { Component } from 'react';
import { available_docks_for_guest } from '../../../Common/CardUtilities';
import { getCardTextureUrl, getTextureUrl } from '../../../Common/TextureTools';


// Held for the future "received cards journal" UI. No longer rendered by
// ReceiveSpecialGuest2d -- the in-flight card now shows on the river (the
// tradelane-in-flight indicator), visible to every seat, so the old
// 40%-width tucked <img> here was redundant (and never actually visible).
class SpecialGuestCard extends Component {

    render() {
        let textureUrl;
        let textureId = this.props.textureId;
        if (this.props.cardId) {
            textureUrl = getCardTextureUrl(this.props.cardId);
        } else {
            textureUrl = getTextureUrl(textureId);
        }
        return <img
            src={textureUrl}
            alt="special-guest"
            style={{ width: '40%' }}
            title={this.props.title}
        />;
    }
}

export default class ReceiveSpecialGuest2d extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    componentDidMount() {
        const cardId = this.props.gamePlayerData.special_card;
        const docks = available_docks_for_guest(
            this.props.gamePlayerData.docks, cardId);
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: docks,
                        callback: this.onClick
                    }
                }));
    }

    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
    }

    onClick = (dockIndex) => {
        this.api.placeSpecialGuest(dockIndex);
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
    }

    render() {
        // No visible UI: the in-flight card is shown on the river (the
        // tradelane-in-flight indicator) for every seat, and the receiver's
        // drop target is the dock highlight dispatched in componentDidMount.
        // Parallel to AddGhost2d's near-pure side-effect shape.
        return <></>;
    }

}
